// LEGACY UI: replace with Field with Input type="date" from @workspace/frontend-ui.
// Don't import this in new code; legacy-ui.json tracks the remaining importers
// and only shrinks (scripts/legacy-ui-check.mjs).
import useLanguage from "@casino/legacy/client/hooks/useLanguage";
import useSite from "@casino/legacy/client/hooks/useSite";
import InlineStack from "@casino/legacy/client/shared/InlineStack";
import Translate from "@casino/legacy/client/shared/i18n/Translate";
import Stack from "@casino/legacy/client/shared/Stack";
import FormError from "@casino/legacyUi/form/FormError";
import useUserGeoLocation from "@casino/legacyUi/form/FormPhoneNumber/hooks/useUserGeoLocation";
import CustomSelect from "@casino/legacyUi/form/FormSelect/CustomSelect";
import buildOptions from "./helpers/buildOptions";
import useDateInput from "./useDateInput";

type Props = {
  name: string;
  initial?: number;
  adultOnly?: boolean;
  error?: string;
  onChange?: (value?: Partial<DayMonthYear>) => void;
  onBlur?: () => void;
};

const DateInput: FC<Props> = (props) => {
  const {
    values,
    dayLabel,
    monthLabel,
    yearLabel,
    minYear,
    maxYear,
    handleChange,
  } = useDateInput(props);
  const { userGeoCountryCode } = useUserGeoLocation();
  const { isBitcasino } = useSite();
  const { code: language } = useLanguage();
  const isJP = userGeoCountryCode === "JP" || language === "ja";
  const isJPBitcasino = isJP && isBitcasino;

  const { error, onBlur } = props;

  type SelectType = "day" | "month" | "year";

  const selectsOrder: SelectType[] = isJPBitcasino
    ? ["year", "month", "day"]
    : ["day", "month", "year"];

  const selects = {
    day: (
      <CustomSelect
        name="day"
        label={dayLabel}
        defaultValue={values?.day ?? ""}
        onChange={handleChange("day")}
        onBlur={onBlur}
        fullWidth
        data-testid="day"
      >
        {buildOptions(1, 31)}
      </CustomSelect>
    ),
    month: (
      <CustomSelect
        name="month"
        label={monthLabel}
        defaultValue={values?.month ?? ""}
        onChange={handleChange("month")}
        onBlur={onBlur}
        fullWidth
        data-testid="month"
      >
        {buildOptions(1, 12)}
      </CustomSelect>
    ),
    year: (
      <CustomSelect
        name="year"
        label={yearLabel}
        defaultValue={values?.year ?? ""}
        onChange={handleChange("year")}
        onBlur={onBlur}
        fullWidth
        data-testid="year"
      >
        {buildOptions(minYear, maxYear, true)}
      </CustomSelect>
    ),
  };

  return (
    <Stack space="0">
      <InlineStack space="0" templateColumns="repeat(3, 1fr)" gridGap="0.5rem">
        {selectsOrder.map((select) => selects[select])}
      </InlineStack>
      {!!error && (
        <FormError>
          <Translate id={error} />
        </FormError>
      )}
    </Stack>
  );
};

export default DateInput;
